import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HttpClientModule} from "@angular/common/http";
import {JsonService} from "./services/json.service";
import {GALLERY_CONFIG, GalleryConfig, GalleryModule} from "ng-gallery";
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AppRoutingModule} from "./app-routing.module.";
import {BrowserModule} from "@angular/platform-browser";
import {AppComponent} from "./app.component";
import {FooterComponent} from "./footer/footer.component";
import {HeaderComponent} from "./header/header.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    GalleryModule,
    RouterModule,
    AppRoutingModule,
    BrowserModule,
    FooterComponent,
    HeaderComponent,
    BrowserAnimationsModule
  ],
  exports: [HttpClientModule],
  providers: [JsonService,
    {
      provide: GALLERY_CONFIG,
      useValue: {
        imageSize: "cover",
        autoHeight: true,
        loop: true,
        loadingStrategy: "lazy",
        loadingAttr: "lazy",
        counter: false,
      } as GalleryConfig
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
